import { Component, OnInit } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { AppUserMenu, AppUserMenuItem } from '../../@core/models/app.user.menu';

import { TimelineService } from "../../@core/data/timeline.service";
import { MenuActionService } from "../../@core/data/menu-action.service";

import { FirebaseHelper } from '../../@core/services/firebase.helper';

@Component({
  selector: "edm-modal-menu",
  templateUrl: "./modal-menu.component.html",
  styleUrls: ["./modal-menu.component.scss"],
  standalone: false
})
export class ModalMenuComponent implements OnInit {

  menu: AppUserMenu;

  constructor(
    public activeModal: NgbActiveModal,
    private timelineService: TimelineService,
    private menuActionService: MenuActionService,
    private modal: NgbModal,
    private firebaseHelper: FirebaseHelper
  ) {
    this.timelineService.timeLine$.subscribe(item=> {
      if (item) {
        this.menu = item?.menu
      }
    })
  }

  ngOnInit(): void {
    this.firebaseHelper.logEvent("screen_view", { screen_name: "home_menu" });
  }

  closeModal(): void {
    this.modal.dismissAll();
  }

  openOrPlay(model: AppUserMenuItem): void {
    this.menuActionService.openOrPlay(model);
  }
}
